import { render, staticRenderFns } from "./CompInfoBoxes.vue?vue&type=template&id=ed4b54f2"
import script from "./CompInfoBoxes.vue?vue&type=script&lang=js"
export * from "./CompInfoBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports